import { Feature } from "features/interfaces";

import page from "./_MapPage/_MapPage";
import { actions, reducer } from "./ducks";
import saga from "./saga";

export const mapFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions,
  page
};
